import type { JSX } from "solid-js";

export function Pill(props: {
  tone?: "green" | "violet" | "surface";
  children: JSX.Element;
  class?: string;
}) {
  const tone = () =>
    props.tone === "violet"
      ? "bg-violet text-white"
      : props.tone === "surface"
        ? "bg-surface2 text-violet"
        : "bg-green text-white";
  return (
    <span
      class={`inline-flex h-5 items-center rounded-[10px] px-3 text-[11px] font-medium leading-[1.25] tracking-[0.11px] ${tone()} ${props.class ?? ""}`}
    >
      {props.children}
    </span>
  );
}
